import { useSetAtom } from 'jotai';
import * as React from 'react';

import { type MediaGalleryItem, mediaGalleryAtom } from './state';

export interface MediaGalleryHookAPI {
    open: (medias: MediaGalleryItem[], startIndex?: number) => void;
}

/**
 * Hook API to control the media gallery.
 */
export function useMediaGallery(): MediaGalleryHookAPI {
    const setMediaGallery = useSetAtom(mediaGalleryAtom);

    return React.useMemo(() => {
        return {
            open: (medias, initialIndex = 0) => {
                setMediaGallery({
                    medias,
                    initialIndex,
                });
            },
        };
    }, [setMediaGallery]);
}
